module.exports = __webpack_public_path__ + "static/media/sobre-relacoes.a1683f75.jpeg";